/**
 * Hamle sınıflandırması — kazanma olasılığı kaybına göre.
 * Eşikler chess.com'un sınıflarına yakın olacak şekilde ayarlandı.
 */

export type MoveClass =
  | "book" // açılış kitabı (src/core/book.ts)
  | "forced" // tek yasal hamle
  | "brilliant" // feda özellikli en iyi hamle (deneme)
  | "best" // motorun birinci tercihi
  | "excellent" // kayıp <= %2
  | "good" // kayıp <= %5
  | "inaccuracy" // kayıp <= %10
  | "mistake" // kayıp <= %20
  | "blunder"; // kayıp > %20

export const CLASS_TR: Record<MoveClass, string> = {
  book: "Kitap hamlesi",
  forced: "Zorunlu hamle",
  brilliant: "Parlak hamle",
  best: "En iyi hamle",
  excellent: "Mükemmel hamle",
  good: "İyi hamle",
  inaccuracy: "Küçük hata",
  mistake: "Hata",
  blunder: "Büyük hata",
};

export const CLASS_EN: Record<MoveClass, string> = {
  book: "Book move",
  forced: "Forced move",
  brilliant: "Brilliant move",
  best: "Best move",
  excellent: "Excellent move",
  good: "Good move",
  inaccuracy: "Inaccuracy",
  mistake: "Mistake",
  blunder: "Blunder",
};

export const CLASS_GLYPH: Record<MoveClass, string> = {
  book: "📖",
  forced: "⊕",
  brilliant: "!!",
  best: "!!",
  excellent: "★",
  good: "✓",
  inaccuracy: "?!",
  mistake: "?",
  blunder: "??",
};

export function classifyLoss(
  winProbLoss: number,
  playedMatchesBest: boolean,
  onlyLegalMove: boolean,
  brilliant = false,
): MoveClass {
  if (onlyLegalMove) return "forced";
  if (brilliant && playedMatchesBest) return "brilliant";
  if (playedMatchesBest) return "best";
  if (winProbLoss <= 0.02) return "excellent";
  if (winProbLoss <= 0.05) return "good";
  if (winProbLoss <= 0.1) return "inaccuracy";
  if (winProbLoss <= 0.2) return "mistake";
  return "blunder";
}
